(() => {
  const ROOT_SELECTOR = '.gf-pit';
  const TAB_SELECTOR = '[data-gf-pit-tab]';
  const PANEL_SELECTOR = '[role="tabpanel"]';

  function refreshTruncators(panel) {
    if (!panel) return;
    panel.querySelectorAll('content-truncator').forEach((el) => {
      if (typeof el.updateButtonVisibility === 'function') {
        el.updateButtonVisibility();
      }
    });
  }

  function activateTab(root, tabs, panels, tab) {
    tabs.forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    let activePanel = null;
    panels.forEach((panel) => {
      const isActive = panel.id === tab.getAttribute('data-ziel');
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
      if (isActive) activePanel = panel;
    });

    refreshTruncators(activePanel);
  }

  function focusTab(root, tabs, panels, index) {
    const tab = tabs[index];
    if (!tab) return;
    activateTab(root, tabs, panels, tab);
    tab.focus();
  }

  function initRoot(root) {
    if (root.dataset.gfPitReady === 'true') return;
    root.dataset.gfPitReady = 'true';

    const tabs = Array.from(root.querySelectorAll(TAB_SELECTOR));
    const panels = Array.from(root.querySelectorAll(PANEL_SELECTOR));
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      const isActive = tab.getAttribute('aria-selected') === 'true';
      tab.setAttribute('tabindex', isActive ? '0' : '-1');

      tab.addEventListener('click', () => {
        activateTab(root, tabs, panels, tab);
      });

      tab.addEventListener('keydown', (event) => {
        const currentIndex = tabs.indexOf(tab);
        let nextIndex = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            nextIndex = (currentIndex + 1) % tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        focusTab(root, tabs, panels, nextIndex);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
